import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=ab9fc884&scoped=true&"
import script from "./customDialog.vue?vue&type=script&lang=js&"
export * from "./customDialog.vue?vue&type=script&lang=js&"
import style0 from "./customDialog.vue?vue&type=style&index=0&id=ab9fc884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9fc884",
  null
  
)

export default component.exports